import React from "react";
import Image from "../assets/retro 1.png";
import Arrow1 from "../assets/Vector (1).png";
import Arrow2 from "../assets/Vector (2).png";
import Arrow3 from "../assets/Vector (3).png";
import Arrow4 from "../assets/Vector (4).png";

const Process = () => {
  return (
    <div className="px-10 mt-10 ">
      <h1 className="text-red-900 text-6xl flex justify-center" data-aos="fade-right" data-aos-duration="2000">
        <span className="font-dancing px-2"> Our </span>Process
      </h1>
      <div className="flex md:flex-row flex-col gap-4 justify-center items-center pt-6">
        <div
          className="flex flex-col justify-center items-center gap-4"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <h1 className="text-red-700 font-bold text-xl flex justify-center">
            Concept Development
          </h1>
          <p className="text-center">
            Transforming unique ideas into actionable strategies which align
            with business vision and audience needs. This crucial aspect
            includes refining initial concepts through meticulous research and
            laying down the foundation for success.
          </p>
          <div data-aos="fade-up" data-aos-duration="1500">
            <img
              className="h-32 w-20 md:block hidden"
              src={Arrow1}
              alt=""
            ></img>
          </div>
        </div>

        <div className="flex md:flex-row flex-col md:mt-36 mt-0 gap-5">
          <div
            className="flex flex-col justify-center items-center gap-4"
            data-aos="fade-up"
            data-aos-duration="2500"
          >
            <h1 className="text-red-700 font-bold text-xl flex justify-center">
              Wireframe Creation
            </h1>
            <p className="text-center">
              Proudly presenting a vision in a blueprint for websites and
              applications, focusing on layout and structure. This way we
              organize both content and functionality well to ensure a
              user-friendly interface.
            </p>
            <div data-aos="fade-up" data-aos-duration="2500">
              <img
                className="h-32 w-10 md:block hidden"
                src={Arrow2}
                alt=""
              ></img>
            </div>
          </div>

          <div
            className="flex flex-col justify-center items-center gap-4"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <h1 className="text-red-700 font-bold text-xl flex justify-center">
              Design Iteration
            </h1>
            <p className="text-center">
              The first draft is never the final draft. We refine and improve
              every design through a repeated cycle of feedback. This helps us
              to ensure our designs meet your needs and project goals
              effectively.
            </p>
            <div data-aos="fade-up" data-aos-duration="3000">
              <img
                className="h-32 w-10 md:block hidden"
                src={Arrow3}
                alt=""
              ></img>
            </div>
          </div>
        </div>

        <div
          className="flex flex-col justify-center items-center gap-4"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <h1 className="text-red-700 font-bold text-xl flex justify-center">
            Responsive Development
          </h1>
          <p className="text-center">
            We ensure to create a website or application that adapts seamlessly
            to any screen and device. A consistent and user-friendly experience
            is what we aim for.
          </p>
          <div data-aos="fade-up" data-aos-duration="1500">
            <img
              className="h-32 w-20 md:block hidden "
              src={Arrow4}
              alt=""
            ></img>
          </div>
        </div>
      </div>
      <img src={Image} alt=""></img>
    </div>
  );
};

export default Process;
